"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTable", {
  enumerable: true,
  get: function get() {
    return _SVBTables.default;
  }
});
var _SVBTables = _interopRequireDefault(require("./src/SVBTables"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }